import { AccountingUserTypeEnum, CurrencyEnum } from '@/enums';
import { TableBody, TableCell, TableRow } from '@/components/ui';
import { DataTableBodyCellDate, TableCellRowLine } from '@/components/custom';
import DataTableBodyCellOptions from './DataTableBodyCellOptions';
import { IAccountingUser } from '@/interfaces';
import { amountToString } from '@/functions';
import { Briefcase, TrendingUp } from 'lucide-react';
import { TEditParams } from '@/hooks/forms/useFormAccountingUser';
import { TCallbackForm } from '@/types';

interface TProps {
    accountingUsers: IAccountingUser[];
    onDelete: (_id: string) => Promise<void>;
    onEdit: (params: TEditParams) => void;
    onSeeDetails: (accountingUser: IAccountingUser, callback?: TCallbackForm<IAccountingUser>) => void;
}

const DataTableBody = ({ accountingUsers, onDelete, onEdit, onSeeDetails }: TProps) => {

    const renderType = (type: AccountingUserTypeEnum) => {
        if (type === AccountingUserTypeEnum.EMPLOYEE) {
            return (
                <div className="flex items-center text-sm text-foreground/80">
                    <Briefcase size={14} className="mr-2 text-muted-foreground" />
                    <span>Employé</span>
                </div>
            );
        }
        return (
            <div className="flex items-center text-sm text-foreground/80">
                <TrendingUp size={14} className="mr-2 text-muted-foreground" />
                <span>Investisseur</span>
            </div>
        );
    };

    return (
        <TableBody>
            {
                accountingUsers.map(
                    (user: IAccountingUser, index: number) => (
                        <TableRow
                            key={user._id}
                            className="h-10 hover:bg-muted/50 cursor-pointer"
                            onClick={() => onSeeDetails(user)}
                        >
                            <TableCellRowLine value={index + 1} />
                            <TableCell className='font-medium py-1'>
                                {user.name}
                            </TableCell>
                            <TableCell className="py-1 text-muted-foreground">
                                {user.role}
                            </TableCell>
                            <TableCell className={`py-1 font-medium ${user.type === AccountingUserTypeEnum.EMPLOYEE ? 'text-foreground' : 'text-blue-600'}`}>
                                {user.type === AccountingUserTypeEnum.EMPLOYEE
                                    ? amountToString(user.baseSalaryEur || 0, CurrencyEnum.EUR)
                                    : `${user.percentage}%`
                                }
                            </TableCell>
                            <TableCell className="py-1">
                                {renderType(user.type)}
                            </TableCell>
                            <DataTableBodyCellDate date={user.createdAt} className="py-1" format='DD MMM YYYY' />
                            <TableCell className='text-right py-1 pe-4' onClick={(e) => e.stopPropagation()}>
                                <DataTableBodyCellOptions
                                    accountingUser={user}
                                    onDelete={onDelete}
                                    onEdit={onEdit}
                                    onSeeDetails={onSeeDetails} />
                            </TableCell>
                        </TableRow>
                    )
                )
            }
        </TableBody>
    );

};

export default DataTableBody;
